import { usePageHeader } from "@/components/layouts/lib/page-header";
import { LegalDocumentCard } from "@/components/legal/LegalDocumentCard";
import { LEGAL_DOCUMENTS } from "@/content/legal";

export default function CguPage() {
  usePageHeader({ title: "Conditions générales d'utilisation" });

  return (
    <div className="max-w-[820px] mx-auto">
      <LegalDocumentCard doc={LEGAL_DOCUMENTS.cgu} />
    </div>
  );
}
